import { Outlet } from "react-router-dom";

export default function MinhasComprasPage() {
  return <Outlet />;
}
